export enum PaginationReduxActions {
  UPDATE_PAGINATION = 'UPDATE_PAGINATION',
}

const setPagination = (
  payload: any
): {
  type: PaginationReduxActions;
  payload: any;
} => ({
  type: PaginationReduxActions.UPDATE_PAGINATION,
  payload,
});

export const PaginationActions = {
  setPagination,
};
